<template>
  <div class="newsDetails-box">
    <defaultheader class="topShow" />
    <mobileHeader></mobileHeader>
    <div class="cententBox">
      <div class="newsPhto">
        <h1 class="title-box">{{ newsDetailsObj.articleTitle }}</h1>
        <!-- <img v-if="newsDetailsObj.articleImg" class="imgBox" :src="newsDetailsObj.articleImg" alt="" /> -->
      </div>
      <div class="ctnBox" v-html="newsDetailsObj.articleValue">
        <!-- <p style="text-align: justify">
          <span style="font-size: 14px"
            ><span style="line-height: 2"
              >1、灯饰的颜色&nbsp;<br />
              事物给人的一印象就是颜色。所以，书房中灯饰的颜色非常重要。一般来说，书房中不宜使用太明亮，发白色的灯光。一是因为遵循厅明室暗的道理，二是亮光会增加人眼睛的负担，非常容易造成视觉疲劳。&nbsp;<br />
              所以，在书房中，应选择淡黄色的光作为主光调。然后在书桌上再选用稍微亮一点的护眼台灯，以供学习工作之用。这样既节能，还有助于使用者的用眼健康。&nbsp;<br />
              2、灯饰的形状&nbsp;<br />
              在所有的形状中，只有方形和圆形比较适合在书房中使用。其中，如果个人是一个比较懒散型或者自制力比较差的人，好在书房中使用方形的灯饰。因为方形是大地的象征，会让人也变得脚踏实地。再者，方形本就给人一种规规矩矩的感觉，会让使用者避免做事没有规矩，没有计划。&nbsp;<br />
              而如果自己本身就是比较死板顽固的人，则好是使用圆形的灯饰来温润一下自己威严的气质。也让自己变得更加随和亲切一些。&nbsp;<br />
              3、灯饰的数量&nbsp;<br />
              在书房中的灯饰不宜过多，一般就是两盏或者三盏为宜。一盏主灯，然后在书桌上摆放一盏台灯。如果有茶几或者其他的桌子，也可以使用一盏落地灯，以便随时移动。&nbsp;<br />
              另外，灯饰都是有自己的磁场的，并且属动性。而书房中需要安静祥和的氛围。所以，不能放置太多的灯饰。否则磁场一乱，就会导致人也变得难以安静，学习和工作都不在状态。</span
            ></span
          >
        </p> -->
      </div>
    </div>
    <a class="mw-btn" style="display: none" href="javascript:window.history.go(-1);">
      <i class="el-icon-arrow-left"></i>
    </a>
    <defaulfooter />
  </div>
</template>

<script>
import {articleDetail, infoList} from '@/api/index'
import mobileHeader from '../components/mobileheader.vue'
import defaultheader from '../components/defaultheader'
import defaulfooter from '@/components/defaulfooter'
export default {
  components: {
    defaultheader,
    defaulfooter,
    mobileHeader
  },
  name: 'newsDetails',
  created() {
    // console.log('这是传过来的参数', this.$route.query)
    this.init(this.$route.query.id)
  },
  data() {
    return {
      newsDetailsObj: {} //新闻内容
    }
  },
  methods: {
    //初始化数据
    init(val) {
      articleDetail({articleId: val}).then(res => {
        // console.log('这是数据', res)
        this.newsDetailsObj = res
        infoList({deptId: 112}).then(res => {
          // console.log('公司基本信息', res)
          document.title = this.newsDetailsObj.articleTitle + '-' + res.companyName + '-' + res.websiteDesc
        })
      })
    }
  }
}
</script>

<style></style>
